import { render } from "./BuekNotIframe.vue?vue&type=template&id=42b07b66&ts=true"
import script from "./BuekNotIframe.ts?vue&type=script&lang=ts&external"
export * from "./BuekNotIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__